class SchedulesOnProfileController {
    /*@ngInject*/
    constructor($rootScope, $scope, $timeout, $uibModal, jobService, jobMatchService, companyService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.isLoading = true;
        this.scheduleActions = [
            "Create",
            "Modify",
            "Cancel"
        ];
        this.activeFeedbackTab = 2;
        this.scheduleAction = "Create";
        //variables
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this._initializeData(false);
        if (this.feedbackType == "PhoneScreen") {
            this.itemType = "phoneScreen";
        }
        else if (this.feedbackType == "Interview") {
            this.itemType = "interview";
        }
    }
    _initializeData(isRefresh) {
        this.isLoading = true;
        this.getCandidateJobMatchCardInfo(() => {
            this.getMoveToInterviewStepPossibility(() => {
                this._checkAvailableFeedbackReports(() => {
                    this._initFileNames();
                    this._loadTabs(isRefresh);
                    this.isLoading = false;
                });
            });
        });
    }
    getCandidateJobMatchCardInfo(successCallback) {
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.jobMatchInfo = data;
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getMoveToInterviewStepPossibility(successCallback) {
        this.meetingService.getMoveToInterviewStepPossibility(this.scheduleId, (data) => {
            this.jobMatchInfo.interviewNextStep = data.interviewNextStep;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = data.canMoveCandidateToInterviewAfterCurrentFeedback;
            if (successCallback) {
                successCallback();
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _checkAvailableFeedbackReports(successCallback) {
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
            let feedbackReports = data.feedbackReportsAvailability;
            this.isPhoneScreenFeedbackAvailable = feedbackReports["phoneScreenFeedbackReport"];
            this.isInterviewFeedbackAvailable = feedbackReports["interviewFeedbackReport"];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _initFileNames() {
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    }
    _loadTabs(isRefresh) {
        this.tabs = [];
        if (this.feedbackType == 'PhoneScreen') {
            this.tabs.push({ name: "Schedule", step: 'Phone Screen', fileName: "", url: "", isLoading: false });
            if (this.isPhoneScreenFeedbackAvailable) {
                this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                this.tabs.push({ name: "Completed Feedback", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
            }
            this.tabs.push({ name: "Feedback", step: 'Phone Screen', fileName: "", url: "", isLoading: false, isActive: true });
            if (this.jobMatchInfo.interviewNextStep) {
                if (this.jobMatchInfo.availableActions.filter(action => action.action === 'Move to Interview').length > 0) {
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false });
                    if (isRefresh) {
                        this.confirmMoveCandidateToInterview();
                    }
                }
                else if (this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback) {
                    //show can be moved after this feedback complete
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false, disabled: true, message: 'Move to Interview action is available only if you completed the current Phone Screen feedback.', disabled: true });
                }
                else {
                    //show complete all to move 
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false, disabled: true, message: 'Move to Interview action is available only if all the Phone Screen feedback(s) have been completed for this candidate.', disabled: true });
                }
            }
        }
        else if (this.feedbackType == 'Interview') {
            this.tabs.push({ name: "Schedule", step: 'Interview', fileName: "", url: "", isLoading: false });
            if (this.allowInterviewSchedule) {
                if (this.isInterviewFeedbackAvailable) {
                    this.interviewFeedbackUrl = "api/jobmatch/getinterviewfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Completed Feedback", step: "Interview", fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
                }
                this.tabs.push({ name: "Feedback", step: 'Interview', fileName: "", url: "", isLoading: false, isActive: true });
            }
            else {
                this.tabs[0].isActive = true;
            }
        }
        this._setActiveTab();
    }
    _setActiveTab() {
        this.activeTab = this.tabs.findIndex(tab => tab.isActive == true);
    }
    feedbackSaveCallback() {
        this._initializeData(true);
    }
    feedbackCompleteCallback() {
        if (this.completeFeedbackCallback) {
            this.completeFeedbackCallback();
        }
        this._initializeData(true);
    }
    confirmMoveCandidateToInterview() {
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-info' style='margin-bottom: 0px;'><i class='fas fa-info-circle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Do you want to move the candidate to the Interview step?",
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this.moveCandidateToInterview();
                }
                else {
                    this.tabs.forEach(tab => {
                        if (tab.name == 'Move to Interview') {
                            tab.isActive = true;
                        }
                        else {
                            tab.isActive = false;
                        }
                    });
                    this._setActiveTab();
                }
            }
        });
    }
    moveCandidateToInterview() {
        let actionType = 'Move to Interview';
        let actionLabel = 'Move to Interview';
        let actionsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'schedulesOnProfileActionsModal',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                jobMatchId: () => {
                    return this.jobMatchInfo.jobMatchId;
                },
                candidateId: () => {
                    return this.jobMatchInfo.id;
                },
                meetingScheduleId: () => {
                    return this.scheduleId;
                },
                externalMeetingCallId: () => {
                    return this.externalMeetingCallId;
                },
                sourceScreen: () => {
                    return this.sourceScreen;
                },
                formalizeActivityPayload: () => {
                    return this.formalizeActivityPayload;
                }
            }
        });
        actionsModal.result.then((callbackObject) => {
            if (callbackObject.callbackType == 'moveCandidate') {
                this.reloadAndMoveToInterviewCallback();
            }
        }, (dismiss) => {
        });
    }
    reloadAndMoveToInterviewCallback() {
        this._initializeData();
        if (this.moveToInterviewCallback) {
            this.moveToInterviewCallback();
        }
    }
    onScheduleCreated() {
        const label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been scheduled successfully.`, "success");
    }
    onScheduleModified() {
        const label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been modified successfully.`, "success");
    }
    onScheduleCancelled() {
        const label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been cancelled successfully.`, "success");
    }
}
SchedulesOnProfileController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', 'jobService', 'jobMatchService', 'companyService', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './schedules-on-profile.html;
import * as TEMPLATE from 'raw-loader!./schedules-on-profile.html';
export const SchedulesOnProfileComponent = {
    selector: 'schedulesOnProfile',
    component: {
        bindings: {
            jobMatchId: '@',
            candidateId: '@',
            saveCallback: '&',
            moveToInterviewCallback: '&',
            completeFeedbackCallback: '&',
            feedbackUserIdsList: '@',
            loginRequired: '<',
            externalCommentRequired: '<',
            feedbackType: '@',
            parentScheduleId: '@',
            scheduleId: '@',
            childScheduleId: '@',
            jobMatchObject: '=',
            jobLocation: '@',
            mode: '@',
            displayFeedback: '<',
            allowInterviewSchedule: '=',
            usersToEditFeedback: '=',
            feedbackReadOnly: '=',
            externalMeetingCallId: '=',
            sourceScreen: '@',
            formalizeActivityPayload: '='
        },
        controller: SchedulesOnProfileController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/schedulesOnProfile/schedules-on-profile.html'
    }
};
//# sourceMappingURL=schedules-on-profile.component.js.map